import React from "react";
import { ChatWindow } from "../types";

interface Props {
  chatWindow: ChatWindow;
}

export default function ContentWidgetPreview({ chatWindow }: Props) {
  const lc = chatWindow.languageConfig || {};
  const sc = chatWindow.styleConfig || {};

  const actionColor = sc.actionColor || "#3B82F6";
  const imageUrl = sc.contentWidgetImageUrl;
  const title = lc.contentWidgetTitle || "Your Title Here";
  const body = lc.contentWidgetBody || "Add a short description to your content widget.";
  const buttonText = lc.contentWidgetButtonText || "Learn More";
  const enabled = lc.contentWidgetEnabled ?? false;

  return (
    <div className="flex flex-col items-center py-8 px-4 w-full">
      <div className="text-xs text-slate-400 mb-3 uppercase tracking-wide font-semibold">
        Content Widget Preview
      </div>

      {/* Phone shell */}
      <div
        className="relative bg-slate-100 rounded-[2rem] shadow-2xl border-4 border-slate-300 overflow-hidden"
        style={{ width: 280, height: 520 }}
      >
        {/* Status bar */}
        <div className="bg-slate-800 h-6 w-full flex items-center justify-center">
          <div className="w-16 h-2 bg-slate-600 rounded-full" />
        </div>

        {/* Chat header */}
        <div
          className="w-full px-4 py-3 flex items-center space-x-2"
          style={{ backgroundColor: actionColor }}
        >
          <div className="w-7 h-7 rounded-full bg-white/30 flex-shrink-0" />
          <div className="flex flex-col">
            <div className="text-white text-xs font-semibold leading-tight">Support</div>
            <div className="text-white/70 text-[10px]">Online</div>
          </div>
        </div>

        {/* Chat body — landing screen */}
        <div className="flex-1 bg-white h-full px-3 py-3 overflow-hidden flex flex-col space-y-2">
          {/* Content card */}
          <div className="rounded-xl border border-slate-200 overflow-hidden shadow-sm bg-white">
            {imageUrl ? (
              <img
                src={imageUrl}
                alt="Content widget"
                className="w-full object-cover"
                style={{ maxHeight: 110 }}
              />
            ) : (
              <div
                className="w-full flex items-center justify-center bg-slate-100 text-slate-400 text-xs"
                style={{ height: 80 }}
              >
                No image uploaded
              </div>
            )}
            <div className="px-3 py-2">
              <div className="text-xs font-semibold text-slate-800 leading-snug mb-1 truncate">
                {title}
              </div>
              <div className="text-[10px] text-slate-500 leading-snug line-clamp-2 mb-2">
                {body}
              </div>
              <button
                className="w-full text-white text-[10px] font-semibold py-1.5 rounded-lg"
                style={{ backgroundColor: actionColor }}
              >
                {buttonText}
              </button>
            </div>
          </div>

          {/* Placeholder for start-chat card */}
          <div className="rounded-xl border border-slate-200 px-3 py-2 bg-white">
            <div className="h-2 bg-slate-100 rounded w-3/4 mb-1" />
            <div className="h-2 bg-slate-100 rounded w-1/2" />
          </div>
        </div>
      </div>

      {!enabled && (
        <div className="mt-3 text-xs text-amber-600 font-medium">
          Widget is disabled — toggle Enable to show it in the chat window.
        </div>
      )}
    </div>
  );
}
